<div
  *transloco="let transloco"
  [ngClass]="{
    'flex-col': !(this.props.iconPre || this.props.iconPost)
  }"
  class="flex">
  <p-inputgroup>
    @if (this.props.iconPre) {
      <p-inputgroup-addon>
        <i [class]="this.props.iconPre"></i>
      </p-inputgroup-addon>
    }
    <input
      [formControl]="this.formControl"
      [formlyAttributes]="this.field"
      [ngClass]="{
        'ng-dirty ng-invalid p-invalid': this.showError
      }"
      [placeholder]="transloco(this.props.placeholder || '')"
      [readonly]="this.props.readonly"
      [type]="this.props.type || 'text'"
      pInputText />
    @if (this.props.iconPost) {
      <p-inputgroup-addon>
        <i [class]="this.props.iconPost"></i>
      </p-inputgroup-addon>
    }
  </p-inputgroup>
</div>
